import axios from 'axios';
import store from '@/store';
import qs from 'qs';

const instance = axios.create({
  baseURL: process.env.DOMAIN,
  headers: {
    Accept: 'application/json',
  },
  paramsSerializer(params) {
    return qs.stringify(params, {
      encode: true,
      arrayFormat: 'brackets',
      skipNulls: true,
    });
  },
});

function errorStatusHandler(status) {
  if (status === 401 && location.pathname !== '/signUp') {
    store.commit('SET_EXPERT', '');
    window.location.href = `/signUp?redirect_path=${location.pathname}`;
  }
}

// Add a request interceptor
instance.interceptors.request.use((config) => {
  store.commit('SET_LOADING', true);
  // inject expert-token to http config
  return {
    ...config,
    headers: store.getters.httpExpertHeader,
  };
}, (error) => {
  store.commit('SET_LOADING', false);
  return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use((response) => {
  store.commit('SET_LOADING', false);
  return response;
}, (error) => {
  store.commit('SET_LOADING', false);
  errorStatusHandler(error.response.status);
  return Promise.reject(error);
});

export default instance;



// WEBPACK FOOTER //
// ./src/plugins/httpExpertClient.js